import { useCallback, useState } from "react";
import { disablePart, enablePart, addPart, appendTaskImages } from "../../models/workflow-drawer/taskPartsModel";

export function useTaskParts(userId) {
  const [pendingIds, setPendingIds] = useState(() => new Set());

  const isPending = useCallback((partId) => pendingIds.has(partId), [pendingIds]);

  const withPending = useCallback(async (partId, fn) => {
    setPendingIds(prev => new Set(prev).add(partId));
    try {
      return await fn();
    } finally {
      setPendingIds(prev => {
        const next = new Set(prev);
        next.delete(partId);
        return next;
      });
    }
  }, []);

  const disable = useCallback((partId, reason) => withPending(partId, () => disablePart(partId, userId, reason)), [userId, withPending]);
  const enable = useCallback((partId) => withPending(partId, () => enablePart(partId, userId)), [userId, withPending]);
  const add = useCallback((part, queryPk) => addPart(part, { userId, queryPk }), [userId]);
  const appendImages = useCallback((queryPk, images) => appendTaskImages(queryPk, userId, images), [userId]);

  return { isPending, disable, enable, add, appendImages };
}
